export default function SettingsPage() {
  return (
    <div className="p-8">
      <div className="max-w-lg space-y-8">
        <div>
          <p className="text-xs text-zinc-500 mb-1">System</p>
          <h1 className="text-xl font-bold text-white">Settings</h1>
        </div>

        <p className="text-sm text-zinc-500">Tidak ada pengaturan global saat ini.</p>
      </div>
    </div>
  )
}
